(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["caynora-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Tabs: Buttons [data-cay-tab="n"] schalten Elemente [data-cay-panel="n"] */
    if (!customElements.get('cay-tabs')) {
      class CayTabs extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (event) => {
            const btn = event.target.closest('[data-cay-tab]');
            if (!btn || !this.contains(btn)) return;
            this.select(btn.dataset.cayTab);
          });
        }

        select(index) {
          this.querySelectorAll('[data-cay-tab]').forEach((el) => {
            const on = el.dataset.cayTab === String(index);
            el.classList.toggle('is-active', on);
            el.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          this.querySelectorAll('[data-cay-panel]').forEach((el) => {
            el.classList.toggle('is-active', el.dataset.cayPanel === String(index));
          });
        }
      }
      customElements.define('cay-tabs', CayTabs);
    }

    /* Slider: scroll-snap-Spur mit Pfeilen, Punkten, Zähler und Vorschaubildern */
    if (!customElements.get('cay-slider')) {
      class CaySlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-cay-track]');
          if (!this.track) return;
          this.slides = Array.from(this.track.children);
          this.prev = this.querySelector('[data-cay-prev]');
          this.next = this.querySelector('[data-cay-next]');
          this.dotsBox = this.querySelector('[data-cay-dots]');
          this.counter = this.querySelector('[data-cay-counter]');
          this.thumbs = Array.from(this.querySelectorAll('[data-cay-thumb]'));

          if (this.dotsBox && !this.dotsBox.children.length) {
            this.slides.forEach((_, i) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'cay-dot';
              dot.setAttribute('aria-label', `Folie ${i + 1}`);
              dot.addEventListener('click', () => this.goTo(i));
              this.dotsBox.appendChild(dot);
            });
          }

          this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
          this.next?.addEventListener('click', () => this.goTo(this.index + 1));
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.cayThumb)))
          );

          this.index = 0;
          let ticking = false;
          this.track.addEventListener(
            'scroll',
            () => {
              if (ticking) return;
              ticking = true;
              requestAnimationFrame(() => {
                ticking = false;
                this.update();
              });
            },
            { passive: true }
          );
          window.addEventListener('resize', () => this.update(), { passive: true });
          this.update();
        }

        visibleCount() {
          const first = this.slides[0];
          if (!first) return 1;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return Math.max(1, Math.round((this.track.clientWidth + gap) / (first.offsetWidth + gap)));
        }

        maxIndex() {
          return Math.max(0, this.slides.length - this.visibleCount());
        }

        goTo(i) {
          const target = Math.max(0, Math.min(i, this.maxIndex()));
          const slide = this.slides[target];
          if (!slide) return;
          this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        }

        update() {
          if (!this.slides.length) return;
          const left = this.track.scrollLeft;
          let best = 0;
          let bestDist = Infinity;
          this.slides.forEach((slide, i) => {
            const d = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
            if (d < bestDist) {
              bestDist = d;
              best = i;
            }
          });
          const atEnd = left + this.track.clientWidth >= this.track.scrollWidth - 4;
          this.index = atEnd ? this.maxIndex() : best;
          const max = this.maxIndex();
          if (this.prev) this.prev.disabled = this.index <= 0;
          if (this.next) this.next.disabled = this.index >= max;
          if (this.counter) this.counter.textContent = `${Math.min(this.index + 1, this.slides.length)} / ${this.slides.length}`;
          if (this.dotsBox) {
            Array.from(this.dotsBox.children).forEach((dot, i) => {
              dot.classList.toggle('is-active', i === this.index);
              dot.hidden = i > max;
            });
          }
          this.thumbs.forEach((thumb) =>
            thumb.classList.toggle('is-active', Number(thumb.dataset.cayThumb) === this.index)
          );
        }
      }
      customElements.define('cay-slider', CaySlider);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
